import * as Widget from './base';

function setup_trigger(config, show_callback) {

  switch (config.widget.trigger_config.type) {
  case "page_load":
    const delay = config.widget.trigger_config.options.delay;
    setTimeout(() => trigger_show(config, show_callback), delay * 1000);
    break;
  case "click":
    const css_selector = config.widget.trigger_config.options.css_selector;
    const clickable_element = document.querySelector(css_selector);

    if (clickable_element) {
      clickable_element.addEventListener('click', function(e) {
        trigger_show(config, show_callback);
      });
    }

    break;
  case "javascript":
    // nothing to do
    break;
  }
}

function trigger_show(config, show_callback) {
  var widget = Widget.get(config);

  show_callback(config);

  if (config.widget.format_config.display_tech == "iframe") {
    sync_iframe_height(widget);
  }
}

export function setup_open(config, show_callback) {
  var widget = Widget.get(config);

  if (config.widget.format_config.display_tech == "iframe") {
    var iframe = widget.querySelector('iframe');

    if (iframe) {
      if (iframe.contentDocument.readyState == "loading") {
        iframe.addEventListener('load', function(e) {
          setup_trigger(config, show_callback);
        });
      } else {
        setup_trigger(config, show_callback);
      }
    }
  } else {
    setup_trigger(config, show_callback);
  }
}

export function sync_iframe_height(element) {
  var iframe = element.querySelector('iframe');
  if (iframe) {
    var height = iframe.contentWindow.document.body.scrollHeight + 20;
    iframe.style.height = `${height}px`;
  }
}
